import {inject, Injectable} from '@angular/core';

import {ACCESS_TOKEN} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {CookieService} from "@numizmat/services/common";

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  private cookieService: CookieService = inject(CookieService);
  private developmentAccessToken: string = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1c2VyLWlkIjoiN2M0MTcyYmEtNWQ4Ni00ZTZlLWE1NzEtNDI4NTM2NTBhZjQzIiwibmJmIjoxNzUyMTE0NDY2LCJleHAiOjE3NTI3MTkyNjYsImlhdCI6MTc1MjExNDQ2Nn0.fMpDK1ULa_htb69kpaDLB9GmRu0elrsSyQ_L-ZOSvwHBSKh7VRpL0Yk5WUn8HGGEIAu36hQzBhYnTfNB2qfpJA';

  public getAccessToken(): string | null {
    if (environment.production) {
      return this.cookieService.getCookie(ACCESS_TOKEN);
    } else {
      return this.developmentAccessToken;
    }
  }

  public setAccessToken(accessToken: string): void {
    this.cookieService.setCookie(ACCESS_TOKEN, accessToken);
    if (!environment.production) {
      this.developmentAccessToken = accessToken;
    }
  }

  public deleteAccessToken(): void {
    this.cookieService.deleteCookie(ACCESS_TOKEN);
    if (!environment.production) {
      this.developmentAccessToken = '';
    }
  }
}
